<template>
    <div :class="{activeHeader: showHeader || acceptHeaderFixed.includes($route.path.replace('/mobile', '')) || (isMobile && sideNav)}" style="width: 100vw; z-index: 999; transition: all 0.3s ease;">
        <div :style="{height: isMobile ? 'auto' : '50px', margin: isMobile ? '0' : '0 auto', padding: isMobile ? '10px 20px 10px 20px' : '0'}" style="width: 100%; max-width: 1180px; display: flex; justify-content: space-between; align-items: center;">
            <div @click="goMain()">
                <logo style="width: 75px; cursor: pointer" />
            </div>
            <Hamburger v-if="isMobile" />
            <div v-if="isMobile" :style="{height: sideNav ? 'calc(var(--vh, 1vh) * 100 - 47px )' : 0, padding: sideNav ? '48px 0 120px 0' : '0'}" style="position: fixed; top: 67px; left: 0; width: 100%; max-width: 100vw; display: flex; flex-direction: column; align-items: flex-start; z-index: 998; background: white; transition: all 0.3s ease; overflow: hidden; padding: 108px 21px 120px 21px">
                <p class="submenu" :class="{activeMobileMenu: ('/mobile' + item.path) == $route.path}" @click="$store.commit('TOGGLE_HAMBURGER_STATE', false), goPage('/mobile' + item.path)" v-for="(item, index) in navTitle" :key="index" :style="{opacity: sideNav ? 1 : 0}"  style="width: 100%; color: black; font-size: 25px; font-weight: 700; line-height: 1.2; transition: all 0.3s ease; padding: 21px">
                    {{item.text}}
                </p>
            </div>
            <div v-if="!isMobile" class="menu_title_wrap" style="height: 29px; display: flex; align-items: center; margin-top: 8px;">
                <p :class="{activeMenu: item.path == $route.path}" @click="goPage(item.path)" v-for="(item, index) in navTitle" :key="index" :style="{marginRight: handleLastIndex(index) ? '32px' : 0}" style="color: WHITE; font-size: 14px; line-height: 1.2;">
                    {{item.text}}
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import Hamburger from "@/components/ChangeHambergerBtn.vue"
import Logo from "../space/Logo.vue"
export default {
    components: {
        Logo,
        Hamburger
    },
    data() {
        return {
            sideNav: false,
            showHeader: false,
            acceptHeaderFixed: [
                '/pages/contact',
                '/pages/join-us',
                '/pages/news',
                '/pages/privacy-policy'
            ],
            navTitle: [
                {
                    'text': '회사소개',
                    'path': '/pages/introduction'
                },{
                    'text': '제품소개',
                    'path': '/pages/production'
                },{
                    'text': '제안 및 사업 문의',
                    'path': '/pages/contact'
                },{
                    'text': '채용',
                    'path': '/pages/join-us'
                },
            ]
        }
    },
    watch: {
        hamburger(val) {
            console.log(val)
            document.body.style.overflowY = val ? 'hidden' : 'auto'
            document.body.style.touchAction = val ? 'none' : 'auto'
            document.body.style.WebkitOverflowScrolling = val ? 'none' : ''
            this.sideNav = val
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.isMobile
        },
        hamburger() {
            return this.$store.state.hamburger
        }
    },
    methods: {
        goMain() {
            if(this.isMobile) {
                this.$store.commit('TOGGLE_HAMBURGER_STATE', false)
            }
            if(this.$route.path == '/pages/intro-pulda') {
                this.$router.go()
            } else {
                if(this.isMobile) {
                    this.$router.push('/mobile/pages/intro-pulda')
                } else {
                    this.$router.push('/pages/intro-pulda')
                }
            }
        },
        goPage(val) {
            if(this.$route.path == val) {
                this.$router.go()
            } else {
                this.$router.push(val)
            }
        },
        handleLastIndex(index) {
            return (index != (this.navTitle.length - 1)) ? true : false
        },
        handleScroll(e) {
            e.preventDefault()
            this.$store.commit('UPDATE_WINDOW_SCROLL_Y', e.target.scrollingElement.scrollTop)
            if(e.target.scrollingElement.scrollTop > 0) {
                this.showHeader = true
            } else {
                this.showHeader = false
            }
        }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll)
        // window.addEventListener('wheel', this.handleScroll)
    },
    beforeDestroy() {
        document.removeEventListener('wheel', this.handleScroll)
    }, 
}
</script>
<style>
    .activeHeader {
        background: white;
        border-bottom: 1px solid #F4F4F4
    }
    .activeHeader .burger2 span {
        background: #595959 !important;
    }
    .activeHeader .burger2 span::before {
        background: #595959 !important;
    }
    .activeHeader .burger2 span::after {
        background: #595959 !important;
    }
    .activeHeader .burger2::before {
        background: #595959 !important;
    }
    .activeHeader .burger2::after {
        background: #595959 !important;
    }
    .activeHeader .menu_title_wrap p {
        color: black !important
    }
    .menu_title_wrap p {
        font-weight: 400;
    }
    .menu_title_wrap p:hover {
        cursor: pointer;
        font-weight: 700;
    }
    .activeMenu {
        font-weight: 700 !important;
    }
    .activeMobileMenu {
        background: #F4F4F4;
    }
    @keyframes height {
        from {
            height: 0
        }
        to {
            height: calc(100% - 81px)
        }
    }
</style>